function applyVantLocale(locale, Locale, enUS, zhTW) {
  if (locale === 'zh-TW') {
    Locale.use('zh-TW', zhTW)
    return
  }

  Locale.use('en-US', enUS)
}

module.exports = { applyVantLocale }
